import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Card, CardContent, CardHeader } from '../../ui/card';

const PageLoadingSkeleton = ({ 
  showHeader = true, 
  sections = 1, 
  cardCount = 3,
  className = ""
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Header Skeleton */}
      {showHeader && (
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-4 w-96" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-10 w-32" />
            <Skeleton className="h-10 w-32" />
          </div>
        </div>
      )}

      {/* Content Sections */}
      {[...Array(sections)].map((_, sectionIndex) => (
        <div key={sectionIndex} className="space-y-4">
          {/* Section Title */}
          <Skeleton className="h-6 w-48" />
          
          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(cardCount)].map((_, cardIndex) => (
              <Card key={cardIndex} className="bg-slate-50 border-slate-200">
                <CardHeader>
                  <Skeleton className="h-5 w-32" />
                </CardHeader>
                <CardContent className="space-y-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-4 w-1/2" />
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PageLoadingSkeleton;